const CONTRACT_INGESTION_API_URLS = {
    startOrchestrator: '/evolveStartOrchestrator',
    getExecutionResult: '/evolveGetExecutionResult'
}

export default CONTRACT_INGESTION_API_URLS
